import React from "react";

import {

ResponsiveContainer,

PieChart,

Pie,

Cell,

Tooltip,

Legend,

} from "recharts";

import "../../styles/PaymentChart.css";

const COLORS=[

"#d62828",

"#2563eb",

"#16a34a",

"#f59e0b",

"#9333ea",

];

const PaymentChart=({data=[]})=>{

return(

<div className="chart-card">

<h3>

Payment Methods

</h3>

<ResponsiveContainer
width="100%"
height={320}
>

<PieChart>

<Pie

data={data}

dataKey="value"

nameKey="name"

outerRadius={110}

label

>

{

data.map((item,index)=>(

<Cell

key={index}

fill={
COLORS[
index%
COLORS.length
]
}

/>

))

}

</Pie>

<Tooltip/>

<Legend/>

</PieChart>

</ResponsiveContainer>

</div>

);

};

export default PaymentChart;